import { render, staticRenderFns } from "./TradeInstruction.vue?vue&type=template&id=5e627390"
import script from "./TradeInstruction.vue?vue&type=script&lang=js"
export * from "./TradeInstruction.vue?vue&type=script&lang=js"
import style0 from "./TradeInstruction.vue?vue&type=style&index=0&id=5e627390&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports